import { render, staticRenderFns } from "./InvoiceRefunded.vue?vue&type=template&id=5a640030&scoped=true"
import script from "./InvoiceRefunded.vue?vue&type=script&lang=js"
export * from "./InvoiceRefunded.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a640030",
  null
  
)

export default component.exports